export default __webpack_public_path__ + "static/media/downEC.13c241bb.png";